import { useEffect, useState } from "react";
import { Sparkles, Loader2, RefreshCw, Wand2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function ModuleInsights({ moduleKey }) {
  const [text, setText] = useState("");
  const [at, setAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [manual, setManual] = useState("");
  const [showManual, setShowManual] = useState(false);

  const loadCached = () =>
    api.get(`/mod/${moduleKey}/insights`).then((r) => { setText(r.data.text || ""); setAt(r.data.at); })
      .catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { loadCached(); }, [moduleKey]);

  const run = async (prompt) => {
    setRunning(true);
    try {
      const r = await api.post(`/mod/${moduleKey}/insights`, { prompt: prompt || "" });
      setText(r.data.text); setAt(r.data.at); setManual(""); setShowManual(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo generar el análisis"); }
    finally { setRunning(false); }
  };

  return (
    <div className="card-surface p-5 mb-6" data-testid="module-insights">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-4 h-4 text-violet" />
        <div className="overline text-navy/40">Análisis automático con IA</div>
        <div className="ml-auto flex items-center gap-2">
          <button onClick={() => setShowManual((v) => !v)} className="btn btn-ghost text-xs" data-testid="insights-manual-toggle"><Wand2 className="w-3.5 h-3.5" /> Manual</button>
          <button onClick={() => run()} disabled={running} className="btn btn-primary text-xs" data-testid="insights-generate">
            {running ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} {text ? "Regenerar" : "Generar análisis"}
          </button>
        </div>
      </div>

      {showManual && (
        <div className="flex gap-2 mb-3">
          <input value={manual} onChange={(e) => setManual(e.target.value)} placeholder="Pídele algo específico (ej. compara este trimestre vs el anterior)…"
            className="w-full bg-white border border-navy/10 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet" data-testid="insights-manual-input" />
          <button onClick={() => run(manual)} disabled={running || !manual.trim()} className="btn btn-outline text-sm" data-testid="insights-manual-run">Analizar</button>
        </div>
      )}

      {loading ? <div className="py-6 flex justify-center text-navy/30"><Loader2 className="w-5 h-5 animate-spin" /></div> :
        !text ? <p className="text-sm text-navy/40" data-testid="insights-empty">Pulsa "Generar análisis" y la IA cruzará la información de todas tus apps financieras para darte un estudio automático.</p> :
        <>
          <div className="text-sm text-navy/80 leading-relaxed space-y-1" data-testid="insights-text">
            {text.split("\n").map((ln, i) => {
              const t = ln.trim();
              if (!t) return <div key={i} className="h-2" />;
              if (t === "---") return <hr key={i} className="border-navy/10 my-2" />;
              if (t.startsWith("### ")) return <div key={i} className="font-semibold text-navy mt-2">{t.slice(4)}</div>;
              if (t.startsWith("## ")) return <div key={i} className="font-editorial text-lg text-navy mt-3">{t.slice(3)}</div>;
              if (t.startsWith("# ")) return <div key={i} className="font-editorial text-xl text-navy mt-2">{t.slice(2)}</div>;
              if (t.startsWith("- ") || t.startsWith("* ")) return <div key={i} className="flex gap-2 pl-1"><span className="text-violet">•</span><span>{t.slice(2).replace(/\*\*/g, "")}</span></div>;
              return <div key={i}>{t.replace(/\*\*/g, "")}</div>;
            })}
          </div>
          {at && <div className="text-[11px] text-navy/35 mt-3">Generado {new Date(at).toLocaleString("es-MX")}</div>}
        </>}
    </div>
  );
}
